import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import CustomPosition from './entries/CustomPosition';
import PredefinedPosition from './entries/PredefinedPosition';
import { EntryContainer } from './EntryContainer';
import { useDroppable } from '@dnd-kit/core';

const Entry = ({
  col,
  index,
  setItems,
  item,
  onFocus,
  descriptionVars,
  showVars,
  imageType,
  imageApiFilter,
  onChange,
  onUnitChange,
  setExpand,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  if (col.hidden) return;

  const posCol =
    col.key.includes('position') &&
    col.key != 'positionableId' &&
    col.key != 'positionableType'
      ? col.key.match(/(\d+)$/)[0]
      : null;

  return (
    <EntryContainer
      col={col}
      showBorder={(posCol && posCol <= item.depth) ?? false}
    >
      {item.positionableType === 'custom' && (
        <CustomPosition
          imageType={imageType}
          imageApiFilter={imageApiFilter}
          onFocus={onFocus}
          col={col}
          item={item}
          onChange={onChange}
          onUnitChange={onUnitChange}
          setItems={setItems}
          descriptionVars={descriptionVars}
          showVars={showVars}
          posCol={posCol}
        />
      )}
      {item.positionableType !== 'custom' && (
        <PredefinedPosition
          onFocus={onFocus}
          col={col}
          item={item}
          onChange={onChange}
          onUnitChange={onUnitChange}
          setItems={setItems}
        />
      )}
    </EntryContainer>
  );
};

export default Entry;
